import httpClient from './httpClient';
const KEY = 'mybeef_verified_session';
export const getVerifiedSession = (email) => {
  try {
    const session = JSON.parse(localStorage.getItem(KEY) || 'null');
    return session?.token && session.expiresAt > Date.now()
      && (!email || session.email === email.trim().toLowerCase()) ? session : null;
  } catch { return null; }
};
export const calibrationOwner = (email) => {
  try {
    const session = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (session?.userId && (!email || session.email === email.trim().toLowerCase())) return session.userId;
  } catch { /* Usa identidade local sem token. */ }
  return email?.trim().toLowerCase() || 'anonymous';
};
export const clearVerifiedSession = () => localStorage.removeItem(KEY);
export const userAccessService = {
  requestCode(email) { return httpClient.post('/user/auth/solicitar', { email }); },
  async confirmCode(email, code) {
    const result = await httpClient.post('/user/auth/confirmar', { email, code });
    localStorage.setItem(KEY, JSON.stringify(result));
    return result;
  },
  async registerAccess(email, sistema) {
    if (!email) return;
    const localSession = JSON.parse(localStorage.getItem('pecuaria_user_session') || '{}');
    const key = 'mybeef_access_session_' + email.trim().toLowerCase() + '_' + (localSession.cachedAt || 'current');
    let sessionId = sessionStorage.getItem(key);
    if (!sessionId) { sessionId = crypto.randomUUID(); sessionStorage.setItem(key, sessionId); }
    return httpClient.post('/user/acesso', { email, sistema, sessionId, eventId: crypto.randomUUID() });
  },
};
